module.exports = __webpack_public_path__ + "static/media/croc.201a3f4c.svg";